"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDensity = getDensity;
const physical_parser_1 = require("physical-parser");
const extractExperimentalData_1 = require("./extractExperimentalData");
/**
 * Returns the refractive index of a compound
 * @param data Data of a compound data request to the PubChem API
 * @returns ExperimentalData
 */
function getDensity(data = {}, options = {}) {
    const density = (0, extractExperimentalData_1.extractExperimentalData)(data, 'Density', {
        parser: (value) => {
            return (0, physical_parser_1.parseDensity)(value, options);
        },
    });
    return density;
}
//# sourceMappingURL=getDensity.js.map